import { useMutation } from '@tanstack/react-query';

import client from './client';
import { AdminListResp, AdminResp, BaseResp, DepartListResp, LocalResp } from './response';
import { SearchRequest } from './SearchRequest';

export interface AdminFormData {
  userId: number;
  account: string;
  isDoubleCheck?: boolean;
  name: string;
  role: string;
  // phone: string;
  activate: string;
  factoryId: string;
  division: string;
  resetPass?: string;
  // factoryCode: string;
  deptId: number;
  shift?: string;
}

export const getAdminList = (req: SearchRequest): Promise<AdminListResp> =>
  client.get('v1/user/list', { params: req });

export const getAdmin = (id: number): Promise<AdminResp> =>
  client.get(`v1/user/${id}`);

const registerAdmin = (admin: AdminFormData): Promise<BaseResp> =>
  client.post('/v1/user/regist', { ...admin });
export const useRegisterAdminMutation = () => useMutation(registerAdmin);

const editAdmin = (admin: AdminFormData): Promise<BaseResp> =>
  client.post(`/v1/user/${admin.userId}`, { ...admin });
export const useEditAdminMutation = () => useMutation(editAdmin);

const deleteAdmin = (id: number): Promise<BaseResp> =>
  client.delete(`/v1/user/${id}`);
export const useDeleteAdminMutation = () => useMutation(deleteAdmin);

export const getDepartList = (): Promise<DepartListResp> =>
  client.get('v1/admin/dept');

// 통계 정보 업데이트
const updateStatistics = (type: number): Promise<BaseResp> =>
  client.post('v1/admin/statistics', { type });
export const useUpdateStatisticsMutation = () => useMutation(updateStatistics);


export const getLocal = (): Promise<LocalResp> => client.get('v1/admin/local');